import React, { useRef } from "react";
import SLOT_STATUS from "constants/slot-status";
import Lottie from "lottie-react";
import ExplosionLottie from "assets/lotties/explosion-3.json";
import { m } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { ReactComponent as CheckIcon } from "assets/icons/check.svg";
import { ReactComponent as XMarkIcon } from "assets/icons/x-mark.svg";

export default function GridSlotStatus({
  status,
  onComplete = () => {},
  children,
}) {
  const lottieRef = useRef(null);

  if (status === SLOT_STATUS.TIMEOUT) {
    return (
      <Lottie
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: true ? 20 : -1,
        }}
        onComplete={onComplete}
        loop={false}
        animationData={ExplosionLottie}
        lottieRef={lottieRef}
        autoPlay={false}
      />
    );
  }

  if ([SLOT_STATUS.SUCCESS, SLOT_STATUS.FAIL].includes(status)) {
    return (
      <m.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
        }}
        onAnimationComplete={onComplete}
        className={twMerge(
          "absolute inset-0 z-30 flex items-center justify-center",
          status === SLOT_STATUS.SUCCESS ? "bg-green-500" : "bg-red-500"
        )}
        transition={{
          duration: 0.5,
        }}
      >
        {status === SLOT_STATUS.SUCCESS && (
          <CheckIcon
            style={{
              width: "32px",
              height: "32px",
            }}
          />
        )}
        {status === SLOT_STATUS.FAIL && (
          <XMarkIcon
            style={{
              width: "32px",
              height: "32px",
            }}
          />
        )}
      </m.div>
    );
  }

  return children;
}
